// api.tizeti.com/api/v1/tracklist
import { API_URL } from '../../../utils/config';

export const GET_TRACKLIST_URL = `${API_URL}/tracklist`;
export const GET_TRACKLIST_CATEGORY_URL = `${API_URL}/tracklistcategory`;
export const SEARCH_TRACKLIST_CATEGORY_URL = `${API_URL}/tracklistcategory/search`;
export const GET_CLASSIFICATION_URL = `${API_URL}/procurement/classification`;
